import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Handler from '../../Handler';
import API from '../../api';
import Utils from '../../api/Utils';
import {
  Button,
  DropdownInput,
  ModalReductionAction,
  ModalReductionView,
  PageHeader,
  SelectBox,
  TablePaging,
  TableReduction,
} from '../../components';
import { SnackbarContext } from '../../contexts';
import { usePagination } from '../../hooks';
import { modalStyle } from '../../styles/style';

export const ReductionListPage = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const DOC = t('DOC_PROCESS', { returnObjects: true });
  const { updateSnackbar } = useContext(SnackbarContext);
  const [status, setStatus] = useState('SELECT_ALL');
  const [search, setSearch] = useState('');
  const [searchType, setSearchType] = useState('Title');
  const [list, setList] = useState(null);
  const [page, totalPage, totalCount, onPageChange, setPage, setTotalPage, setTotalCount] = usePagination(0, 9);
  const [actionOpen, setActionOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedNextAction, setSelectedNextAction] = useState(null);
  const [lastSearchBody, setLastSearchBody] = useState(null);
  const isFirstMount = useRef(true);
  const ROUTE_PATH = t('ROUTE_PATH', { returnObjects: true });

  const requestSearch = () => {
    requestNewList(0);
  };

  const tableRowClick = (index) => {
    console.log('tableRowClick index', index);
  };

  const tableCallback = (next_action, item) => {
    switch (next_action) {
      case 'IssueCredit': {
        console.log('IssueCredit');
        history.push('/credit/issue');
        return;
      }
      case 'History': {
        console.log('History move');
        history.push('/reduction/detail/' + item.seq);
        break;
      }
      case 'View': {
        setSelectedItem(item);
        setSelectedAction(item.lastDoc.actionSeq);
        setViewOpen(true);
        break;
      }
      case 'ModifyWriting': {
        history.push('/reduction/writing/' + item.seq);
        break;
      }
      case 'RemoveWriting': {
        API.ReductionCert.PostNextAction(item.seq, {
          nextAction: 'RemoveWriting',
        }).then(
          (res) => {
            closeActionModal();
            requestNewList();
          },
          (err) => {
            updateSnackbar({
              type: 'error',
              open: true,
              message: err.data.message,
            });
          },
        );
        break;
      }
      case 'ImproveReductionCertStart': {
        let target_seq = null;
        if (item) {
          target_seq = item.seq;
        }
        if (selectedItem) {
          target_seq = selectedItem.seq;
        }
        API.ReductionCert.PostNextAction(target_seq, {
          nextAction: 'ImproveReductionCertStart',
        })
          .then((res) => {
            closeActionModal();
            closeViewModal();
            requestNewList();
            setSelectedAction({
              status: 'RequestMoveWriting',
              seq: target_seq,
            });
            setViewOpen(true);
          })
          .catch((err) => {
            updateSnackbar({
              type: 'error',
              open: true,
              message: err.data.message,
            });
          });
        break;
      }
      case 'CancelWaiting': {
        setSelectedItem(item);
        setSelectedAction(item.lastDoc.actionSeq);
        setSelectedNextAction(next_action);
        setActionOpen(true);
        break;
      }
      default: {
        setSelectedItem(item);
        setSelectedAction(item.lastDoc.actionSeq);
        setSelectedNextAction(next_action);
        setActionOpen(true);
      }
    }
  };

  const handleModalRequest = (body) => {
    API.ReductionCert.PostNextAction(selectedItem.seq, body)
      .then((res) => {
        let result = res.data;
        console.log('PostNextAction  result', result);
        closeActionModal();
        requestNewList(0);
      })
      .catch((err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      });
  };

  const closeActionModal = () => {
    setActionOpen(false);
    setSelectedItem(null);
    setSelectedAction(null);
    setSelectedNextAction(null);
  };

  const closeViewModal = () => {
    setViewOpen(false);
    setSelectedItem(null);
    setSelectedAction(null);
    setSelectedNextAction(null);
  };

  //server
  const requestNewList = (paramsOrPage, skipUrlUpdate = false) => {
    let params = null;

    // 파라미터 객체가 직접 전달된 경우 (URL 파라미터 복원 시)
    if (typeof paramsOrPage === 'object' && paramsOrPage !== null) {
      params = {
        ...paramsOrPage,
        size: Handler.VARIABLES.PAGE_LIMIT,
      };
      setLastSearchBody({ ...params });
    }
    // init_page가 숫자로 전달되면 새로운 검색 파라미터 생성 (검색 조건 변경)
    else if (paramsOrPage !== undefined) {
      params = {
        page: paramsOrPage,
        size: Handler.VARIABLES.PAGE_LIMIT,
        searchType: searchType,
        searchValue: search,
        status: status !== 'SELECT_ALL' ? status : '',
      };
      setLastSearchBody({ ...params });
    }
    // undefined이면 기존 검색 조건 유지 (페이지 변경만)
    else {
      params = {
        ...lastSearchBody,
        status: status !== 'SELECT_ALL' ? status : '',
        page: page,
        size: Handler.VARIABLES.PAGE_LIMIT,
      };
    }

    // URL 업데이트 스킵 (뒤로가기 등으로 이미 URL이 설정된 경우)
    if (!skipUrlUpdate) {
      replaceSearchQuery(params);
    }

    API.ReductionCert.GetList(params)
      .then((res) => {
        let result = res.data;
        setList(result.content);
        setTotalPage(result.totalPages);
      })
      .catch((err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      });
  };

  const replaceSearchQuery = (params) => {
    history.replace({
      search: Utils.ObjectToParams({
        ...params,
        page: params.page || page,
        size: Handler.VARIABLES.PAGE_LIMIT,
      }),
    });
  };

  // URL 변경 시 상태 복원 및 API 호출
  useEffect(() => {
    const params = history?.location?.search ? Utils.ParamsToObject(history.location.search) : {};

    if (Object.keys(params).length > 0) {
      // URL에 파라미터가 있으면 상태 복원
      const initialPage = params.page !== undefined ? Number(params.page) : 0;
      const initialSearchBody = {
        ...params,
        page: initialPage,
      };

      setPage(initialPage);
      if (params.searchType) setSearchType(params.searchType);
      if (params.searchValue) setSearch(params.searchValue);
      if (params.status) setStatus(params.status);

      // requestNewList로 API 호출 (URL은 이미 설정되어 있으므로 업데이트 스킵)
      requestNewList(initialSearchBody, true);
    } else {
      // URL에 파라미터가 없으면 기본 검색 실행
      requestSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.search]);

  // page 또는 status 변경 시 API 호출 (초기 로드 이후에만)
  useEffect(() => {
    // 첫 마운트 시에는 실행하지 않음 (첫 번째 useEffect에서 이미 처리됨)
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }

    if (lastSearchBody) {
      requestNewList(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, status]);

  return (
    <article className='basic-page'>
      <PageHeader type='reduction' title={t(ROUTE_PATH['REDUCTION_STATUS'])}></PageHeader>
      <article className='content__wrapper'>
        <div className='search__container between'>
          <div className='select__box'>
            <SelectBox
              value={status}
              onChange={(value) => {
                setStatus(value);
                setPage(0);
              }}
              meta={{
                key: 'status',
                menus: [
                  {
                    label: t('STATUS') + ' ' + t('ALL'),
                    value: 'SELECT_ALL',
                  },
                  {
                    label: t('TEMP_SAVE'),
                    value: 'Writing',
                  },
                  {
                    label: DOC['WAITING'],
                    value: 'Waiting',
                  },
                  {
                    label: DOC['REVIEW'],
                    value: 'Audit',
                  },
                  {
                    label: DOC['REQ_FOR_REVISION'],
                    value: 'ImprovementRequest',
                  },
                  {
                    label: `${DOC['FINAL_APPROVED']} / ${DOC['COMMENCEMENT_APPROVED']}`,
                    value: 'Approved',
                  },
                  {
                    label: DOC['REJECTED'],
                    value: 'Rejected',
                  },
                  {
                    label: t('CANCEL'),
                    value: 'Canceled',
                  },
                ],
              }}
            ></SelectBox>
          </div>
          <div className='input__box'>
            <DropdownInput
              value={search}
              menuValue={searchType}
              onChange={(value, key) => {
                setSearch(value);
              }}
              onMenuChange={(value, key) => {
                setSearchType(value);
              }}
              onEnter={() => {
                requestSearch();
              }}
              meta={{
                style: { width: '446px' },
                placeholder: t('KEYWORD'),
                menus: [
                  {
                    value: 'Title',
                    label: t('PROJECT'),
                  },
                  {
                    value: 'Id',
                    label: t('PROJECT_ID'),
                  },
                ],
              }}
            ></DropdownInput>
            <Button
              style={{ width: '80px', height: '50px', marginLeft: 12 }}
              onClick={() => {
                requestSearch();
              }}
              label={t('SEARCH')}
            ></Button>
          </div>
        </div>
        <TableReduction data={list} rowClick={tableRowClick} callback={tableCallback}></TableReduction>
        <div style={{ height: 40 }}></div>
        <TablePaging page={page} totalPage={totalPage} onChange={onPageChange}></TablePaging>
      </article>
      <Modal open={actionOpen} onClose={closeActionModal}>
        <Box sx={modalStyle}>
          <ModalReductionAction
            action={selectedAction}
            nextAction={selectedNextAction}
            requestAction={handleModalRequest}
            onClose={closeActionModal}
          ></ModalReductionAction>
        </Box>
      </Modal>
      <Modal open={viewOpen} onClose={closeViewModal}>
        <Box sx={modalStyle}>
          <ModalReductionView
            action={selectedAction}
            onClose={closeViewModal}
            requestAction={tableCallback}
          ></ModalReductionView>
        </Box>
      </Modal>
    </article>
  );
};
